import { render } from "./BIView.vue?vue&type=template&id=4afbae6b"
import script from "./BIView.vue?vue&type=script&lang=js"
export * from "./BIView.vue?vue&type=script&lang=js"

import exportComponent from "c:\\dev\\davca-cm\\davca-cm\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__